import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import { Auth0Provider } from "@auth0/auth0-react";
import { authSettings, callbackUri, isMobile } from './AppSettings'
import { MenuPanelProvider } from './MenuPanelContext'
import debounce from 'lodash.debounce';


const container = document.getElementById('root')!;
const root = createRoot(container);
store.subscribe(
  debounce(() => {
  }, 800)
);
root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={authSettings.domain}
      clientId={authSettings.client_id}
      useRefreshTokens={authSettings.useRefreshTokens}
      useRefreshTokensFallback={authSettings.useRefreshTokensFallback}
      cacheLocation={ isMobile ? 'localstorage' : 'memory'}
      authorizationParams={{
        redirect_uri: callbackUri,
        audience: authSettings.audience,
        scope: authSettings.scope 
      }}
    >
      <Provider store={store}>
        <MenuPanelProvider>
          <App />
        </MenuPanelProvider>
      </Provider>
    </Auth0Provider>
  </React.StrictMode>
);